/* RESPONSIBLE TEAM: team-knowledge-foundations */
export enum Status {
  Pending = 0,
  InProgress = 1,
  Completed = 2,
  Failed = 3,
  Skipped = 4,
  SentToAnswerBot = 5,
}
